<template>
  <div class="return-processing">
    <ReturnAside @selectProjectFnc="selectProjectFnc"></ReturnAside>
    <div class="return-processing-right">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <div class="top">
          <el-form-item label="日期" prop="date">
            <el-date-picker
              class="top-date"
              v-model="ruleForm.date"
              type="date"
              placeholder="请选择日期"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="数量" prop="nums">
            <el-input
              v-model="ruleForm.nums"
              placeholder="请输入数量"
              clearable
              disabled
            ></el-input>
          </el-form-item>
        </div>

        <div class="return-info">
          <div class="main-title">运单信息</div>
          <div class="waybill-info">
            <el-form-item label="运单号" prop="waybillNo" >
              <el-input
                v-model="ruleForm.waybillNo"
                placeholder="请填项信息"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="寄件人" prop="sender">
              <el-input
                v-model="ruleForm.sender"
                placeholder="请填项信息"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="（选填）手机号"
              prop="phone"
              class="amount"
            >
              <el-input
                v-model="ruleForm.phone"
                placeholder="请填项信息"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="remarks">
            <el-form-item label="备注" prop="remarks">
              <el-input
                type="textarea"
                v-model="ruleForm.remarks"
                placeholder="请填写信息"
                clearable
                resize="none"
              ></el-input>
            </el-form-item>
          </div>

          <div class="main-title">商品信息</div>
          <div
            class="return-goods"
            v-for="(item, index) in ruleForm.returnGoodsInfo"
            :key="index"
          >
            <div class="return-goods-content">
              <div class="return-goods-top">
                <el-form-item
                  label="商品条码"
                  :prop="'returnGoodsInfo.' + index + '.goodsBarCode'"
                  :rules="[
                    { required: true, message: '请输入商品条码', trigger: 'blur' },
                  ]"
                >
                  <el-input
                    v-model="item.goodsBarCode"
                    placeholder="请填写信息"
                    clearable
                    @keyup.enter.native="getGoodsNameByGoodsBarCode(item.goodsBarCode, index)"
                    @focus="focusGoodsBarCode(index)"
                    @blur="blurGoodesBarCode(item.goodsBarCode, index)"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="商品名称"
                  :prop="'returnGoodsInfo.' + index + '.goodsName'"
                  :rules="[
                    { required: true, message: '请输入商品名称', trigger: 'blur' },
                  ]"
                >
                  <el-select
                    ref="goodsNameRef"
                    class="white"
                    v-model="item.goodsName"
                    placeholder="请填项信息"
                    clearable
                    filterable
                    @visible-change="visibleChangeSelect($event,index)"
                    @blur.native.capture="childrenSelectBlur"
                    @change="changeGoodsName"
                  >
                    <el-option
                      v-for="(item, index) in goodsNameList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="效期"
                >
                  <el-input
                    class="valid-date"
                    v-model="item.validDate"
                    placeholder="请填写时间"
                    clearable
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="生产日期"
                  :prop="'returnGoodsInfo.' + index + '.manufactureDate'"
                >
                  <el-date-picker
                    v-date-format="{ keys: ['ruleForm', 'returnGoodsInfo', index, 'manufactureDate'] }"
                    v-model="item.manufactureDate"
                    type="date"
                    placeholder="请选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="changeProductionDate(index)"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
              <div class="return-goods-hislist">
                <el-form-item
                  label="商品数量"
                  :prop="'returnGoodsInfo.' + index + '.quantity'"
                  :rules="[
                    { required: true, message: '请输入商品数量', trigger: 'blur' },
                  ]"
                >
                  <el-input
                    v-model="item.quantity"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="次品数量"
                  :prop="'returnGoodsInfo.' + index + '.badQuantity'"
                  :rules="[
                    { required: true, message: '请输入次品数量', trigger: 'blur' },
                  ]"
                >
                  <el-input
                    v-model="item.badQuantity"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="index !== 0" class="del-goods">
                  <el-button type="text" class="btn-red-text" @click="removeGoodsInfo(index)">删除此商品</el-button>
                </el-form-item>
              </div>
            </div>
            <div class="border"></div>
          </div>
          
          <div class="add-goodsInfo" >
            <el-button type="text" class="btn-text" @click="addGoodsInfo">+添加商品</el-button>
          </div>
        </div>
      </el-form>
      <div class="footer">
        <el-button class="btn-gray" @click="cancel">清空</el-button>
        <el-button
          class="btn-blue"
          @click="submitFnc"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ChargeRegister from "models/charge-register";
import ReturnAside from '@/components/layout/return-aside.vue';
import { formatTimeToDate, calculationDays, debounce } from "common/js/util";
export default {
  components: {
    ReturnAside
  },

  data() {
    return {
      warehouseId: null,
      customerId: null,
      projectId: null,
      //设置今天以后不可选
      pickerOptions: {
        //限制时间
        selectableRange: this.selectableRange(),
        // 限制日期
        disabledDate: this.disabledDate,
      },
      goodsBarCodeIndex: null,
      // 商品名称列表
      goodsNameList: [],
      // 退货服务中商品信息下标
      goodsNameIndex: null,
      ruleForm: {
        date: formatTimeToDate(new Date()),
        remarks: "",
        nums: "",
        waybillNo: "",
        sender: "",
        phone: "",
        returnGoodsInfo: [
          {
            goodsBarCode	: "",
            goodsName: "",
            quantity: 1,
            badQuantity: 0,
            // 叛次天数
            judgeBadDay: 9999,
            validDate: "",
            // 生产日期
            manufactureDate: '',
          },
        ],
      },
      rules: {
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        waybillNo: [
          {
            required: true,
            message: "请输入运单号",
            trigger: "blur",
          },
        ],
      },
      timerId: null,
      timerId2: null,
      timerId3: null
    }
  },
  watch: {
    ruleForm: {
      handler() {
        let num = 0
        this.ruleForm.returnGoodsInfo.map(i => {
          num += Number(i.quantity)
        })
        this.ruleForm.nums = num
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.watchBarCodeScanningGun()
    // 提交防抖
    this.submitFnc = debounce(() => {
      this.submitForm('ruleForm')
    }, 800)
    this.debounceGoodsName = debounce((val, index) => {
      this.initGoodsName(val, index)
    }, 200)
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
    clearTimeout(this.timerId2)
    clearTimeout(this.timerId3)
  },
  destroyed() {
    window.document.onkeypress = null
  },

  methods: {
    initGoodsName(code, index) {
      let customerId = this.customerId
      ChargeRegister.getGoodsNameByCode(code, customerId).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.name = i.goodsName
            obj.validDate = i.validDate
            obj.judgeBadDay = i.judgeBadDay
            arr.push(obj)
          })
          this.goodsNameList = arr
          this.ruleForm.returnGoodsInfo[index].goodsName = this.goodsNameList.length > 0 ? this.goodsNameList[0].name:''
          this.ruleForm.returnGoodsInfo[index].validDate = this.goodsNameList.length > 0 ? this.goodsNameList[0].validDate:''
          this.ruleForm.returnGoodsInfo[index].judgeBadDay = this.goodsNameList.length > 0 ? this.goodsNameList[0].judgeBadDay: 9999
          this.changeProductionDate(index)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 选择项目
    */
    selectProjectFnc(v) {
      this.warehouseId = v.warehouseId
      this.customerId = v.customerId
      this.projectId = v.projectId
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data
          let warehouseId = this.warehouseId;
          let customerId = this.customerId;
          let projectId = this.projectId;
          let billDate = this.ruleForm.date;
          let checkNum = Number(this.ruleForm.nums);
          let expressCode = this.ruleForm.waybillNo
          let sender = this.ruleForm.sender
          let phoneNumber = this.ruleForm.phone
          let remarks = this.ruleForm.remarks;
          this.ruleForm.returnGoodsInfo.map(i => {
            if (i.goodsName.name) {
              i.goodsName = i.goodsName.name
            }
          })
          let goodsList = this.ruleForm.returnGoodsInfo
          let flag = false
          goodsList.map(val => {
            for(let key in val){
              if (key != 'validDate' && key != 'manufactureDate') {
                if(!(val[key]).toString()){
                  flag = true
                  return; 
                }
              }
            }
          })
          if (flag) {
            this.$message.error('请填项完整的商品信息')
            return
          }
          data = {
            warehouseId,
            customerId,
            projectId,
            billDate,
            checkNum,
            expressCode,
            sender,
            phoneNumber,
            goodsList,
            remarks
          };
          ChargeRegister.postRefundSave(data).then((res) => {
            if (res.success) {
              this.$message.success('保存成功');
              this.cancel()
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
    cancel() {
      this.ruleForm.remarks = ""
      this.ruleForm.nums = ""
      this.ruleForm.waybillNo = ""
      this.ruleForm.sender = ""
      this.ruleForm.phone = ""
      this.ruleForm.returnGoodsInfo = [
        {
          goodsBarCode	: "",
          goodsName: "",
          quantity: 1,
          badQuantity: 0,
          // 叛次天数
          judgeBadDay: 9999,
          validDate: "",
          manufactureDate: '',
        },
      ]
    },

    selectableRange() {
      let date = new Date();
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      let time = `${hour}:${minute}:${second}`;
      const selectableRange = `${time}-23:59:59`;
      return selectableRange;
    },

    disabledDate(date) {
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return date.getTime() > Date.now();
    },
    
    addGoodsInfo() {
      let obj = {
        goodsBarCode	: "",
        goodsName: "",
        quantity: 1,
        badQuantity: 0,
        // 叛次天数
        judgeBadDay: 9999,
        validDate: "",
        manufactureDate: '',
      };
      this.ruleForm.returnGoodsInfo.push(obj);
    },
    
    removeGoodsInfo(i) {
      this.ruleForm.returnGoodsInfo.splice(i, 1);
    },

    childrenSelectBlur(e){
      let str = e.target.value
      let obj =  this.goodsNameList.find(item => { return item.name === str })
      if (str) {
        this.timerId3 = setTimeout(() => {
          this.ruleForm.returnGoodsInfo[this.goodsNameIndex].goodsName = str
          this.ruleForm.returnGoodsInfo[this.goodsNameIndex].validDate = obj?obj.validDate:''
          this.ruleForm.returnGoodsInfo[this.goodsNameIndex].judgeBadDay = obj?obj.judgeBadDay: 9999
          this.changeProductionDate(this.goodsNameIndex)
        },400)
      }
    },

    changeGoodsName(e){
      let obj =  this.goodsNameList.find(item => { return item.name === e })
      this.timerId = setTimeout(() => {
        this.ruleForm.returnGoodsInfo[this.goodsNameIndex].validDate = this.goodsNameList.length > 0 ? obj.validDate:''
        this.ruleForm.returnGoodsInfo[this.goodsNameIndex].judgeBadDay = this.goodsNameList.length > 0 ? obj.judgeBadDay: 9999
        this.changeProductionDate(this.goodsNameIndex)
      },200)
    },

    visibleChangeSelect(e,i) {
      if (!e) {
        this.goodsNameIndex = i
      }
    },
    
    /** 
     * @desc 根据商品条码获取商品名称
    */
    getGoodsNameByGoodsBarCode(val, index) {
      this.debounceGoodsName(val, index)
    },

    focusGoodsBarCode(index) {
      this.goodsBarCodeIndex = index
    },
    
    blurGoodesBarCode(val, index) {
      this.goodsBarCodeIndex = null
      this.getGoodsNameByGoodsBarCode(val, index)
    },

    /** 
     * @desc 选择生产日期
    */
    changeProductionDate(index) {
      // 当天日期-生产日期>判次天数；则次品数量===商品数量，否则为0
      if (calculationDays(this.ruleForm.returnGoodsInfo[index].manufactureDate,formatTimeToDate(new Date().getTime())) > this.ruleForm.returnGoodsInfo[index].judgeBadDay) {
        this.ruleForm.returnGoodsInfo[index].badQuantity = this.ruleForm.returnGoodsInfo[index].quantity
      } else {
        this.ruleForm.returnGoodsInfo[index].badQuantity = 0
      }
    },
    
    /**
     * @desc 监听扫码枪
     */
    watchBarCodeScanningGun() {
      let code = ''
      let lastTime, nextTime // 上次时间，最新时间
      let lastCode, nextCode // 上次按键，最新按键
      window.document.onkeypress = (e) => {
        // 获取按键
        if (window.event) { // IE
          nextCode = e.keyCode
        } else if (e.which) {
          nextCode = e.which
        }

        // 如果触发了回车事件（扫码结束时间）
        if (e.which === 13) {
          // 扫码枪的速度很快，手动输入的时间不回让code的长度大于2，所以这里只对邵美琪有效
          if (code.length < 3) return
          // 获取到扫码枪输入的内容，做别的操作
          this.parseQRCode(code)
          lastCode = ''
          lastTime = ''
          return
        }

        // 记录最新时间
        nextTime = new Date().getTime()
        // 如果上次时间和上次按键为空
        if (!lastTime && !lastCode) {
          // 清空上次的条形码
          code = ''
          code += e.key
          console.log('扫码开始', code);
        }
        // 如果有上次时间和上次按键
        if (lastTime && lastTime && nextTime - lastTime > 100) {  
          // 当扫码前有keypress事件时，防止首字母缺失
          code = e.key
          console.log('防止首字母缺失', code);
        } else if(lastCode && lastTime) {
          code += e.key
          console.log('扫码中', code);
        }
        lastCode = nextCode
        lastTime = nextTime
      }
    },

    /**
     * @desc 获取到扫码枪输入的内容，做别的操作
     */
    parseQRCode(code) {
      if (code.length === 13 || code.length === 14 || code.length === 15 || code.length === 16 || code.length === 17) {
        console.log('barCode', code);
      } else if (code.length === 23 || code.length === 30) {
        console.log('B类条形码', code);
      } else if (code.length === 0) {
        console.log('请输入条码', code);
        this.$message({
          message: '请输入条码',
          type: 'error'
        })
        return
      } else {
        console.log('条码不合法', code);
        this.$message({
          message: '条码不合法',
          type: 'error'
        })
        return
      }
      this.ruleForm.returnGoodsInfo[this.goodsBarCodeIndex].goodsBarCode = code
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/production/return-processing.scss';
</style>
